module.exports = __webpack_public_path__ + "static/integration_bg_1024x611-a7ec539aa3038a587f829f931b403b78.webp";